/**
 * Copyright (c) 2019 2020 2021 Halo, 7thCode. All Rights Reserved.
 * see license.txt
 */

import {Component, OnInit} from "@angular/core";

import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {NewsService} from "../../news/news.service";
import {ActivatedRoute} from "@angular/router";
import {SessionableComponent} from "../../platform/base/components/sessionable.component";
import {SessionService} from "../../platform/base/services/session.service";
import {IErrorObject} from "../../../../types/platform/universe";
import {PaymentService} from "../payment/payment.service";
import {AuthLevel} from "../../../../types/aig/universe";
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: 'aigia-app-news',
	templateUrl: './news.component.html',
	styleUrls: ['./news.component.css']
})

export class NewsComponent extends SessionableComponent implements OnInit {

	public news: any[];
	public location: any[];

	public params: any = {};

	public isSubscribe: boolean;

	/**
	 *
	 */
	constructor(
		protected session: SessionService,
		protected paragraph: NewsService,
		private stripeService: PaymentService,
		private domSanitizer: DomSanitizer,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session);
	}

	/**
	 * @returns none
	 */
	private draw(): void {

		let level: number = 20;
		if (this.isSubscribe) {
			level = 10;
		}

		if (this.auth < AuthLevel.user) {
			level = 10;
		}

		const news_query: any = {
			$and: [
				{"content.enabled": true},
				{"content.category": "news"},
				{"content.status": {$gte: level}}
			]
		}

		this.paragraph.query(news_query, {sort: {create: -1}, limit: 10, skip: 0}, (error, result: any[]) => {
			this.news = result;
		});

		const location_query: any = {
			$and: [
				{"content.enabled": true},
				{"content.category": "location"},
				{"content.status": {$gte: level}}
			]
		}

		this.paragraph.query(location_query, {sort: {create: -1}, limit: 10, skip: 0}, (error, result: any[]) => {
			this.location = result;
		});

	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {
				this.route.queryParams.subscribe(params => { // paramが与えられているか、の"subscribe"
					this.params = params;
					this.stripeService.is_subscribe((error: IErrorObject, result: boolean) => { //課金してるか？の"is_subscribe"
						if (!error) {
							this.isSubscribe = result;
							this.draw();
						} else {
						}
					});
				});
			}
		});
	}

	/**
	 * todo
	 */
	public sanitize(contaminated: string): SafeHtml {
		return this.domSanitizer.bypassSecurityTrustHtml(contaminated);
	}

	/**
	 * todo
	 */
	public imagePath(article: any): string {
		let path: string = "";
		if (article.accessory) {
			if (article.accessory.images) {
				if (article.accessory.images.length > 0) {
					if (article.accessory.images[0].name) {
						path = "/pfiles/get/" + article.accessory.images[0].name;
					}
				}
			}
		}
		return path;
	}

}
